// @flow

/**
 * Feature Flags allows to partially activate or deactivate user features.
 */

import { createSelector } from 'reselect'
import { getRoot } from './rootSelector'
import type { FluxStandardAction } from '../types'

export const FEATURE_ANALYTICS_PAGE = 'FEATURE_ANALYTICS_PAGE'
export const POLL_TAGS = 'POLL_TAGS'

export const isFeatureEnabled = (feature: string) =>
  createSelector(
    getRoot,
    ({ featureFlags }) => featureFlags[feature]
  )

const initialState = {
  [FEATURE_ANALYTICS_PAGE]: true,
  [POLL_TAGS]: false,
}

export default function reducer(
  state: Object = initialState,
  action: FluxStandardAction
) {
  switch (action.type) {
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/stores/featureFlags.js